import React, { useEffect, useRef } from "react";
import { ADSENSE_CLIENT, ADS_ENABLED } from "../lib/adsConfig";

// A single responsive AdSense unit. The loader script lives in public/index.html;
// here we just render the <ins> and register it with exactly one push().
export const AdUnit = ({ slot, minHeight = 120, className = "", testid = "ad-unit", label = true }) => {
  const pushed = useRef(false);

  useEffect(() => {
    if (!ADS_ENABLED || !slot || pushed.current) return;
    const t = setTimeout(() => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        pushed.current = true;
      } catch (e) {
        /* adsbygoogle not ready yet — ignored */
      }
    }, 0);
    return () => clearTimeout(t);
  }, [slot]);

  if (!ADS_ENABLED || !slot) return null;

  return (
    <div data-testid={testid} className={`cv-ad my-8 text-center w-full max-w-full overflow-hidden ${className}`}>
      {label && (
        <p className="font-mono-cv text-[9px] tracking-[0.2em] uppercase text-[#B8AC9C] mb-2">Advertisement</p>
      )}
      <ins
        className="adsbygoogle"
        style={{ display: "block", minHeight }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};
